<template>
  <teleport to="#app-notification">
    <topbar-notification
      v-if="moment().isSameOrBefore(dayOfEvent, 'day')"
      :checkpoint="checkpoint.CONTACERTA_SESSION_BANNER"
    >
      <bg-text>
        Sessão Transfeera ContaCerta: conheça casos reais e aplicações práticas do validador de
        dados bancários | 02/06 às 11h, ao vivo | <a href="https://materiais.transfeera.com/sessao-transfeera-contacerta">Inscreva-se</a>!
      </bg-text>
    </topbar-notification>
  </teleport>
</template>

<script setup>
import TopbarNotification from '@/commons/components/presentational/TopbarNotification.vue';
import checkpoint from '@/commons/constants/checkpoint';
import { BgText } from '@transfeeradev/bridge';
import moment from '@transfeeradev/moment';

const dayOfEvent = moment('2026-06-02');
</script>
